import Vue from 'vue';

export default {

  // 获取个人消息列表
  getMessageList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/message/user/getMessageList', params);
  },

  // 获取消息未读数量
  getUnreadMessageNum() {
    return Vue.axios.get('/api/v1.0/chanquan/message/user/getUnreadMessageNum');
  },

  // 全部标记为已读
  updateAllReadMessage () {
    return Vue.axios.get('/api/v1.0/chanquan/message/user/updateAllReadMessage');
  },

  // 修改消息为已读状态
  updateMessageToReadStatus (messageId, messageType) {
    return Vue.axios.get('/api/v1.0/chanquan/message/user/updateMessageToReadStatus?messageId='+ messageId +'&messageType='+ messageType);
  }

};
